import React from 'react'
import styledComponents from "styled-components";
import {
    Box,
    Card,
    CardActions,
    CardContent,
    Divider,
    Grid,
    Typography,
    TextField,
    Button
} from "@mui/material";

const Container = styledComponents.div`
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
`;

const Mitra = () => {
    return (
        <Container>
            <Divider />
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h5" color="gray">
                        KEMITRAAN
                    </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                    <img 
                        src="https://wnj.web.id/home/assets/img/gallery/2022.jpg"
                        style={{ width: '100%' }}
                    />
                </Grid>
                <Grid item xs={6} md={3}>
                    <img 
                        src="https://wnj.web.id/home/assets/img/gallery/AGEN%20Kolibri%202022.jpg"
                        style={{ width: '100%' }}
                    />
                </Grid>
                <Grid item xs={6} md={3}>
                    <img 
                        src="https://wnj.web.id/home/assets/img/gallery/mitraKolibri%202022.jpg"
                        style={{ width: '100%' }}
                    />
                </Grid>
                <Grid item xs={6} md={3}>
                    <img 
                        src="https://wnj.web.id/home/assets/img/gallery/maker%20Kolibri%202022.jpg"
                        style={{ width: '100%' }}
                    />
                </Grid>
            </Grid>
        </Container>
    )
}

export default Mitra
